/**
 * App Logo Component.
 *
 * Renders the TradeRoute octopus logo at the specified size,
 * sitting directly on the surface with no background container.
 * Falls back to an emoji if the image fails to load.
 */

import { clsx } from "clsx";

interface AppLogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const sizeStyles = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-14 w-14",
  xl: "h-18 w-18",
};

function AppLogo({ size = "md", className }: AppLogoProps) {
  return (
    <div
      className={clsx(
        "flex items-center justify-center shrink-0",
        sizeStyles[size],
        className,
      )}
    >
      <img
        src="/logo.png"
        alt="TradeRoute"
        className="h-full w-full object-contain"
        data-no-dim
        onError={(e) => {
          const target = e.currentTarget;
          target.style.display = "none";
          const parent = target.parentElement;
          if (parent) {
            const fallback = document.createElement("span");
            fallback.textContent = "\uD83D\uDC19";
            fallback.className = "text-xl";
            parent.appendChild(fallback);
          }
        }}
      />
    </div>
  );
}

export default AppLogo;
